import type { EventBannerItemStyles } from '~/features/event-list';
import { tw } from '~/utils';

export const eventCarouselStyles = tw<EventBannerItemStyles>({
  box: 'border-grey-100 inline-block overflow-hidden rounded-sm border-1 border-solid',
});
